<template>
    <div id="enterpriseOrder">
        <!-- top -->
        <div class="enterpriseOrder-top">
            <div class="enterpriseOrder-top-title">
                <span>企业订单</span>
                <!-- 提示帮助图标 -->
                <div class="attention">
                    <div class="attention-model">
                        <i></i>
                        <ul>
                            <li>
                                <p>付费单价（元）
                                    <span>每坐席每年的价格</span>
                                </p>
                            </li>
                            <li>
                                <p>付费时长（年）
                                    <span>购买每个坐席的使用期限</span>
                                </p>
                            </li>
                            <li>
                                <p>付费坐席(个)
                                    <span>购买的坐席数</span>
                                </p>
                            </li>
                            <li>
                                <p>总金额(元)
                                    <span>=付费单价*付费时长*付费坐席</span>

                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="searchCondition">
            <div class="searchLine">
                <div class="searchUnit">
                    <label>订单时间</label>
                    <el-date-picker @change="dateRangeChange" v-model="datePickerModel" type="daterange" align="right" :placeholder="this.selected.order_date_start +' - '+ this.selected.order_date_end" :picker-options="DatePickerOptions">
                    </el-date-picker>
                </div>
                <div class="searchUnit">
                    <label>订单号</label>
                    <el-input v-model="selected.order_id"></el-input>
                </div>
                <div class="searchUnit">
                    <label>企业名称</label>
                    <el-select v-model="company_selected" placeholder="全部">
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="searchUnit"></div>
            </div>
            <div class="searchLine">
                <div class="searchUnit">
                    <label>付费单价</label>
                    <el-select v-model="selected.price" placeholder="全部">
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option v-for="item in price_options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="searchUnit">
                    <label>付费时长</label>
                    <el-select v-model="selected.year" placeholder="全部">
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option v-for="item in year_options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="searchUnit">
                    <label>付费坐席</label>
                    <div class="siteScoped">
                        <el-input @change="payMin" class="scoped" placeholder="" v-model="selected.seat_min"></el-input>
                        <span class="siteScopedText">至</span>
                        <el-input @change="payMax" class="scoped" placeholder="" v-model="selected.seat_max"></el-input>
                    </div>
                </div>
                <div class="searchUnit">
                    <label>坐席状态</label>
                    <el-select v-model="selected.state" placeholder="全部">
                        <el-option key="" label="全部" value=""></el-option>
                        <el-option v-for="item in state_options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="button">
                    <el-button type="primary" @click="searchOrders()">搜索</el-button>
                    <a @click="dumpOrders()" class="derive"></a>
                </div>
            </div>
        </div>
        <!-- content -->
        <div class="enterpriseOrder-content">
            <!-- table栏 -->
            <el-table :data="tableData">
                <el-table-column prop="inserted_at" label="订单时间">
                </el-table-column>
                <el-table-column prop="order_id" label="订单号">
                </el-table-column>
                <el-table-column prop="company" label="企业名称">
                </el-table-column>
                <el-table-column prop="single_price" label="付费单价（元）">
                </el-table-column>
                <el-table-column prop="year" label="付费时长（年）">
                </el-table-column>
                <el-table-column prop="seat" label="付费坐席（个）">
                </el-table-column>
                <el-table-column prop="total_price" label="总金额（元）">
                </el-table-column>
                <el-table-column prop="state" label="坐席状态">
                </el-table-column>
                <el-table-column prop="started_at" label="生效时间">
                </el-table-column>
                <el-table-column prop="ended_at" label="到期时间">
                </el-table-column>
            </el-table>
            <!-- <el-pagination :current-page.sync="current_page" :total="total_num" :page-size="selected.page_length" @current-change="clickPage" small layout="prev, pager, next">
            </el-pagination> -->
            <!-- 导入子组件-分页器 -->
            <subpagination  :paginationCurrentPage="currentPage" :totalToPag="total_num" @current-change="clickPage"></subpagination>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import '../../statics/css/enterpriseOrder.scss'
// 导入分页子组件
import subpagination from "../subcomponent/subPaginationCom.vue";
import qs from 'qs';
    export default {
        data() {
            return {
                tableData: [],
                current_page: 1,
                total_num: 0,
                all_companies: [],
                options: [],
                price_options: [],
                year_options: [],
                seat_min: "",
                seat_max: "",
                state_options: [{label: "待付费", value: 0},
                                {label: "未生效", value: 1},
                                {label: "使用中", value: 2},
                                {label: "已到期", value: 3}],
                selected: {
                    page: 1,
                    page_length: 15,
                    order_date_start: "",
                    order_date_end: "",
                    order_id: "",
                    price: "",
                    year: "",
                    seat_min: "",
                    seat_max: "",
                    state: ""
                },
                company_selected: "",
                // 日期选择器设置
                DatePickerOptions: {
                    shortcuts: [{
                        text: '最近60天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近30天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近7天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                //绑定日期选择器
                datePickerModel: "",
                //公司总数
                companyTotal:0,
                currentPage:1

            }
        },
        created() {
            this.setDate(30);
            this.fetchOptions();
        },
        methods: {
            fetchOptions() {  // 获取选项参数
                this.$ajax.post(
                    "/api/order_options",
                    qs.stringify({})
                ).then(res => {
                    this.all_companies = res.data.data.companies;
                    for (var i = 0; i < this.all_companies.length; i ++) {
                        this.options[i] = {value: i, label: this.all_companies[i].company};
                    }
                    var prices = res.data.data.prices;
                    for (var i = 0; i < prices.length; i ++) {
                        this.price_options[i] = {value: prices[i], label: prices[i]};
                    }
                    var years = res.data.data.years;
                    for (var i = 0; i < years.length; i ++) {
                        this.year_options[i] = {value: years[i], label: years[i]};
                    }
                    this.searchOrders()
                })
            },
            // 搜索
            searchOrders(){  
               //点击搜索按钮，传值分页器，让分页器页数为1
                this.currentPage = 1;
                this.selected.server_uid = "";
                this.selected.prefix = "";
                this.selected.company = "";
                if ( this.all_companies[this.company_selected] ) {
                    for (var i in this.all_companies[this.company_selected]) {
                        this.selected[i] = this.all_companies[this.company_selected][i];
                    }
                }
                this.selected.seat_min = this.selected.seat_min === "0" ? 0 : parseInt(this.selected.seat_min) || "";
                this.selected.seat_max = this.selected.seat_max === "0" ? 0 : parseInt(this.selected.seat_max) || "";
                this.$ajax.post(
                    "/api/search_order",
                    qs.stringify(this.selected)
                ).then(res => {
                    this.tableData = res.data.data.orders
                    this.total_num = res.data.data.total_num
                })
                this.current_page = 1
            },
            clickPage(page) {
                this.currentPage = page;
                this.$ajax.post(
                    "/api/get_order_page",
                    qs.stringify({page: page})
                ).then(res => {
                    this.tableData = res.data.data
                })

            },
            dumpOrders() {
                this.$ajax.post(
                    "/api/dump_orders",
                    qs.stringify(this.selected)
                ).then(res => {
                    var url = res.data.data;
                    window.open(url);
                })
            },
            setDate(days) { //默认显示最近x天的时间
                var now = new Date();
                var days_before = new Date(now.valueOf() - days * 86400000);
                this.selected.order_date_start = days_before.Format("yyyy-MM-dd");
                this.selected.order_date_end = now.Format("yyyy-MM-dd");
            },
            dateRangeChange(val) {  //设置下拉框默认显示时间和显示相应的数据
              if (val) {
                this.selected.order_date_start = val.split(" ")[0];
                this.selected.order_date_end = val.split(" ")[2];
              }
            },
            //根据分页器页数获取当前列表数据
            getCurrentListData(page) {


                this.$ajax.post(
                    "/api/company_page",
                    qs.stringify({page:page})
                ).then(res => {
                    console.log(res);
                    this.companyListDatas = res.data.data;
                    for(var i = 0; i < this.companyListDatas.length; i++) {
                        //  this.companyListDatas[i].charge_seats_ing = 1;
                        if(this.companyListDatas[i].charge_seats_ing != 0) {
                            this.companyListDatas[i].leave_msg_num = "无限制";
                            this.companyListDatas[i].rb_msg_num = "无限制";
                        }
                        if(this.companyListDatas[i].leave_msg_num == "infinite") {
                            this.companyListDatas[i].leave_msg_num = "无限制"
                        }
                        if(this.companyListDatas[i].rb_msg_num == "infinite") {
                            this.companyListDatas[i].rb_msg_num = "无限制"
                        }
                    }
                })
            },
            payMin() {
                setTimeout(()=> {

                if(this.selected.seat_min.length==1){
                    this.selected.seat_min=this.selected.seat_min.replace(/[^1-9]/g,'')
                }else{
                    this.selected.seat_min=this.selected.seat_min.replace(/\D/g,'')
                }   
                },100)

            },
            payMax() {
                setTimeout(()=> {
                if(this.selected.seat_max.length==1){
                    this.selected.seat_max=this.selected.seat_max.replace(/[^1-9]/g,'')
                }else{
                    this.selected.seat_max=this.selected.seat_max.replace(/\D/g,'')
                }
                },100)
            }
        },
        // 注册子组件
        components: {
            subpagination
        }
    }
</script>
</html>


// WEBPACK FOOTER //
// enterpriseOrder.vue?66171f20